<template>
	<div
		class=""
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<countdown
			:key="index"
			:options="node.options"
			:previewDevice="previewDevice"
		/>
	</div>
</template>

<script>
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
import {
	getNodeStyle,
	// eslint-disable-next-line
} from '@/lib/helper';

// eslint-disable-next-line
import Countdown from '@/components/funnels/pagebuilder/parts/countdown/index.vue';

export default {
	name: 'NodeCountdown',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		Countdown,
	},
	data() {
		return {
			index: 0,
		};
	},
	computed: {},
	watch: {
		'node.options.theme': {
			deep: true,
			handler() {
				this.index++;
			},
		},
		'node.options.date': {
			deep: true,
			handler() {
				this.index++;
			},
		},
		'node.options.hours': {
			deep: true,
			handler() {
				this.index++;
			},
		},
		'node.options.minutes': {
			deep: true,
			handler() {
				this.index++;
			},
		},
	},
	methods: {
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
				'padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
	},
};
</script>

<style scoped></style>
